import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeFanComponent } from './home-fan/home-fan.component';
import { IncommingEventsResolver } from './home-fan/incomming-events.resolver';
import { HomeOrgaComponent } from './home-orga/home-orga.component';
import { ContactComponent } from './contact/contact.component';
import { FaqComponent } from './faq/faq.component';
import { TermsComponent } from './terms/terms.component';
import { DemoComponent } from './demo/demo.component';
import { SEOResolver } from '../shared/resolvers/seo.resolver';

const routes: Routes = [
  {
    path: '',
    component: HomeFanComponent,
    resolve: {
      events: IncommingEventsResolver,
      SEOTranslations: SEOResolver,
    },
  },
  {
    path: 'pro',
    component: HomeOrgaComponent,
    resolve: {
      SEOTranslations: SEOResolver,
    },
  },
  {
    path: 'contact',
    component: ContactComponent,
  },
  {
    path: 'faq',
    redirectTo: 'faq/vendeur',
  },
  {
    path: 'faq/:faqSection',
    component: FaqComponent,
  },
  {
    path: 'mentions-legales',
    component: TermsComponent,
  },
  {
    path: 'demo',
    component: DemoComponent,
  },
  /*
  {
    path: 'blog',
    component: BlogComponent,
  },
  {
    path: 'blog/:articleSlug',
    component: ArticleComponent,
  },
  */
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomeRoutingModule { }
